<div class="wrap">
  <div class="selector">
    @for (p of info; track $index; let i = $index) {
      <button
        type="button"
        [class.on]="pantalla === i"
        (click)="ir(i)"
        [title]="p.sub"
      >
        {{ i + 1 }}
      </button>
    }
    <span class="sub">{{ info[pantalla].sub }}</span>
  </div>

  <!-- Botón de la categoría: imagen o pill de color. -->
  <ng-template #btnTpl let-btn="btn" let-h="h">
    @if (btn.urlImagen) {
      <img class="btn-img" [src]="btn.urlImagen" [style.height.px]="h" alt="" />
    } @else {
      <!-- Igual que PanicButton: pastilla del ancho del contenido, texto blanco, ícono por función,
           y el `error` del tema si el botón no tiene color. -->
      <div
        class="btn-pill"
        [style.background]="btn.color || colorError"
        [style.height.px]="h"
        [style.border-radius.px]="h / 2"
      >
        <app-icono-funcion [funcion]="btn.funcion" [tamano]="h / 2.5" />
        <span>{{ btn.texto || btn.nombre || "Pánico" }}</span>
      </div>
    }
  </ng-template>

  <!-- Marco y barra inferior iguales a los de `provisionador-preview` (el resto de las vistas). -->
  <div class="phone">
    <div
      class="screen"
      [class.has-fondo]="!!vm.fondo"
      [style.--brand]="vm.brand"
    >
    <div class="pantalla">
      @if (vm.fondo) {
        <img class="fondo" [src]="vm.fondo" alt="" />
      }
      <div class="columna">
        @if (!bloques.length) {
          <div class="vacia">
            Pantalla {{ pantalla + 1 }} vacía: el vecino no la ve.
          </div>
        }
        @for (b of bloques; track $index) {
          @switch (b.tipo) {
            @case ("imagen") {
              <div
                class="b-imagen"
                [class.con-fondo]="!!fondoImagen(b)"
                [class.sin-cargar]="!imagen(b) && !fondoImagen(b)"
                [title]="
                  !imagen(b)
                    ? 'Imagen ' + (b.imagen || 'arriba') + ' sin cargar: en la app no se ve'
                    : ''
                "
                [style.height.px]="imagen(b) || fondoImagen(b) ? px(b.alto) : null"
                [style.background]="fondoImagen(b)"
              >
                @if (imagen(b); as url) {
                  <img [src]="url" alt="" [class.ancho]="b.ajuste === 'ancho'" />
                }
              </div>
            }
            @case ("botones") {
              <div class="b-botones" [class.expandir]="b.expandir">
                @if (!botonesDe(b).length) {
                  <div class="sin-botones">Pieza sin botones</div>
                }
                @for (fila of filas(b); track $index) {
                  <div class="fila-botones">
                    @for (btn of fila; track $index) {
                      <div class="celda">
                        <ng-container
                          *ngTemplateOutlet="
                            btnTpl;
                            context: { btn: btn, h: altoBoton(b) }
                          "
                        ></ng-container>
                      </div>
                    }
                  </div>
                }
              </div>
            }
            @case ("fila") {
              @if (celdas(b).length) {
                <div class="b-fila" [style.height.px]="px(b.alto)">
                  @for (c of celdas(b); track $index) {
                    <div class="celda">
                      @if (c.boton) {
                        <ng-container
                          *ngTemplateOutlet="
                            btnTpl;
                            context: { btn: c.boton, h: px(b.alto) - 8 }
                          "
                        ></ng-container>
                      } @else {
                        <!-- Mismas imágenes que el nativo (PanicButton / NavButton). -->
                        <img
                          class="item-img"
                          [class.nav]="c.item === 'mas' || c.item === 'atras'"
                          [class.apagado]="c.vacia"
                          [src]="imagenItem(c.item)"
                          [alt]="ITEM[c.item].l"
                          [style.height.px]="px(b.alto) - 8"
                          [title]="
                            c.vacia
                              ? 'Lleva a la pantalla ' +
                                (pantalla + 2) +
                                ', que está vacía: en la app no se ve hasta que tenga piezas. Tocalo para armarla.'
                              : ITEM[c.item].l
                          "
                          (click)="click(c)"
                        />
                      }
                    </div>
                  }
                </div>
              }
            }
            @case ("texto") {
              <div
                class="b-texto"
                [style.font-size.px]="px(b.tamano)"
                [style.font-weight]="b.negrita ? 700 : 400"
                [style.color]="b.color || colorPrimario"
              >
                {{ b.texto || "Texto" }}
              </div>
            }
            @case ("espacio") {
              <div [style.height.px]="px(b.alto)"></div>
            }
          }
        }
      </div>
    </div>
    <!-- Barra inferior del shell: Inicio (fijo) + secciones según módulos + Más -->
    <div class="navbar">
      <div class="navitem on">
        <span class="ni-ic">🏠</span><span class="ni-l">Inicio</span>
      </div>
      @for (s of vm.navSecciones.slice(0, 3); track s.l) {
        <div class="navitem">
          <span class="ni-ic">{{ s.ic }}</span><span class="ni-l">{{ s.l }}</span>
        </div>
      }
      <div class="navitem">
        <span class="ni-ic">☰</span><span class="ni-l">Más</span>
      </div>
    </div>
    </div>
  </div>
</div>
